import { CtaButton } from '@deckee/api-app-main';
import { Box, Button, Card, Paragraph } from '@deckee/deck-hand';
import React, { FC, MouseEvent } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { getSelectedCategory } from '../../../../../services/store/modules/marketplace';
import CategoryIcon from '../CategoryIcon/CategoryIcon';
import MarketplaceListingHeading from '../MarketplaceListingHeading/MarketplaceListingHeading';
import RatingAndCount from '../RatingAndCount/RatingAndCount';

interface MarketplaceListingCardProps {
  name: string;
  distance: string;
  summary?: string;
  coverImage?: string;
  partner: boolean;
  ctaButtons: CtaButton[];
  onCtaButtonClick: (ctaButton: CtaButton, e: MouseEvent<HTMLElement>) => void;
  onViewOnMap: () => void;
  starRating?: string;
  ratingsTotal?: number;
}

const StyledImage = styled(Box)`
  height: 200px;
  background-image: url(${(props) => props.image});
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;

  @media (min-width: 600px) {
    height: 300px;
  }

  ${({ theme }) => `
      ${theme.mediaQueries.medium} {
        height: 200px;
      }
    `}
`;

const MarketplaceListingCard: FC<MarketplaceListingCardProps> = ({
  name,
  distance,
  summary,
  coverImage,
  partner,
  ctaButtons,
  onCtaButtonClick,
  onViewOnMap,
  starRating,
  ratingsTotal,
}) => {
  const selectedCategory = useSelector(getSelectedCategory);

  return (
    <Card>
      {partner && coverImage ? (
        <StyledImage image={coverImage} />
      ) : (
        <CategoryIcon iconBaseShape={selectedCategory?.icon} />
      )}

      <MarketplaceListingHeading name={name} partner={partner} />

      <Card.Body>
        {starRating !== undefined && (
          <RatingAndCount displayValue={starRating} total={ratingsTotal} />
        )}
        {distance && (
          <Paragraph fontSize="inherit" color="darkergrey">
            {distance} away
          </Paragraph>
        )}
        <Paragraph fontSize="inherit">{summary}</Paragraph>

        <Box
          mt="3"
          display="flex"
          justifyContent="flex-start"
          alignItems="center"
          flexWrap="wrap"
        >
          {ctaButtons.map((button) => (
            <Button
              mt="2"
              mr="2"
              key={button.label}
              outlined={button.type === 'secondary'}
              href={button.url}
              onClick={(e: MouseEvent<HTMLElement>) =>
                onCtaButtonClick(button, e)
              }
            >
              {button.label}
            </Button>
          ))}

          <Button mt="2" outlined onClick={onViewOnMap}>
            View map
          </Button>
        </Box>
      </Card.Body>
    </Card>
  );
};

MarketplaceListingCard.defaultProps = {
  summary: 'No summary available',
  coverImage: undefined,
  starRating: undefined,
  ratingsTotal: undefined,
};

export default MarketplaceListingCard;
